module.exports = __webpack_public_path__ + "static/media/LS_3DSprite_ShouShou.0079.png.337bae03.jpg";